import reducerRegistry from 'core/lib/store/reducer-registry';
import {
  MODAL_Flag,
  MODAL_Flag_SUCCESS,
  MODAL_Flag_ERROR,
} from "../action-types/userInfo";
import labelModalFlag from '../reducers/labelModalFlag'

reducerRegistry.register('labelModalFlag', labelModalFlag)

export function modalFlag(callback) {
  return {
    types: [MODAL_Flag, MODAL_Flag_SUCCESS, MODAL_Flag_ERROR],
    callAPI: () => callback()
  };
}
